import { fork } from "redux-saga/effects";
import dfdWatcher from "../../modules/dfd/saga/DfdWatcher";

export default function* rootSaga() {
  yield fork(dfdWatcher);
}
